/**
 * Remove the prefix from a Shopify ID.
 */
export const trimId = (id: string): string => {
  const parts = id.split('/');
  return parts[parts.length - 1];
};
